"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Filter2 = _interopRequireDefault(require("./Filter"));

var _creative = require("../../../constants/creative");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BlurFilter = /*#__PURE__*/function (_Filter) {
  (0, _inherits2["default"])(BlurFilter, _Filter);

  var _super = _createSuper(BlurFilter);

  /*
   * radius length in PX
   * @type {number}
   */
  function BlurFilter() {
    var _this;

    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (0, _classCallCheck2["default"])(this, BlurFilter);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_radius", void 0);
    _this._radius = radius;
    return _this;
  }

  (0, _createClass2["default"])(BlurFilter, [{
    key: "getName",
    value: function getName() {
      return _creative.FILTERS_TO_FILTER_NAMES[_creative.FILTERS.BLUR];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.radius;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        radius: this.radius
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "blur(".concat(this.radius, "px)");
    }
  }, {
    key: "toCanvasString",
    value: function toCanvasString() {
      if (this.radius <= 0) return undefined;
      return "blur(".concat(BlurFilter.convertValueForCanvas(this.radius), "px)");
    }
    /**
     * combine with another Blur filter
     *
     * @param filter
     */

  }, {
    key: "combine",
    value: function combine(filter) {
      if (!BlurFilter.isBlurFilter(filter)) {
        throw new Error('filter must be of type BlurFilter');
      }

      this.radius += filter.radius;
    }
    /**
     * copy the current BlurFilter
     *
     */

  }, {
    key: "copy",
    value: function copy() {
      return new BlurFilter(this.radius);
    }
    /**
     * Checks if object is an instance of BlurFilter
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(value) {
      this._radius = value;
    }
  }], [{
    key: "isBlurFilter",
    value: function isBlurFilter(inputObject) {
      return inputObject instanceof BlurFilter;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json) {
        return null;
      }

      return new BlurFilter(json.radius);
    }
    /*
     * Utility Helper to help covert our builder's blur value
     * to HTML Canvas Blur value
     *
     * @param radius
     * @returns {number}
     */

  }]);
  return BlurFilter;
}(_Filter2["default"]);

exports["default"] = BlurFilter;
(0, _defineProperty2["default"])(BlurFilter, "NAME", 'blur');
(0, _defineProperty2["default"])(BlurFilter, "BUILDER_BLUR_MULTIPLIER", 4);
(0, _defineProperty2["default"])(BlurFilter, "convertValueForCanvas", function () {
  var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return radius / BlurFilter.BUILDER_BLUR_MULTIPLIER;
});